import React from "react";
import { NavLink } from "react-router-dom";
import { WordRestrictions } from "../../../../models/extension/WordExtention";
import CourseNoteCategoryView from "../../../../models/views/education/CourseNoteCategoryView";
import CourseNoteCategoryService from "../../../../services/education/CourseNoteCategoryService";
import CourseNoteService from "../../../../services/education/CourseNoteService";
import NotFoundDataInDate from "../../../shared/not-found-data-in-date/NotFoundDataInDate";
import { resolveCourseMediaUrl } from "../course-note.data";
import "../CourseNote.scss";
import CourseCategoriesState, { CourseCategoriesProps } from "./CourseCategories.models";
import "./CourseCategories.scss";

export default class CourseCategories extends React.PureComponent<CourseCategoriesProps, CourseCategoriesState> {
    courseNoteCategoryService: CourseNoteCategoryService;
    courseNoteService: CourseNoteService;

    constructor(props: CourseCategoriesProps) {
        super(props);
        this.courseNoteCategoryService = new CourseNoteCategoryService();
        this.courseNoteService = new CourseNoteService();
        this.state = {
            categories: [],
        };
    }

    componentDidMount() {
        this.getData();
    }

    componentDidUpdate(prevProps: CourseCategoriesProps) {
        if (prevProps.courseId !== this.props.courseId) {
            this.getData();
        }
    }

    getData = () => {
        const self = this;
        const courseId = this.props.courseId;
        if (courseId == null) return;

        this.courseNoteService.getCourseTitleValues().then(function (courses) {
            const course = (courses ?? []).find((item) => item.value === courseId);
            self.setState({ course });
        });

        this.courseNoteCategoryService.getByCourseId(courseId).then(function (response) {
            self.setState({ categories: response ?? [] });
        });
    };

    render(): React.ReactNode {
        const courseTitle = this.state.course?.title ?? "";
        const courseImage = resolveCourseMediaUrl(this.state.course?.imageUrl);
        const categories = this.state.categories.filter((category) => category.isActive);

        return (
            <div
                className="dropdown-list course-note-area course-categories-area"
                style={{ height: "90vh" }}
            >
                {this.courseHeaderView(courseTitle, courseImage)}

                <div className="categories-hint">
                    <label>دسته بندی موردنظر خود را انتخاب کنید</label>
                </div>

                {categories.length > 0 ? (
                    this.categoriesView(categories, courseTitle, courseImage)
                ) : (
                    <NotFoundDataInDate title="موردی یافت نشد" />
                )}
            </div>
        );
    }

    courseHeaderView(courseTitle: string, courseImage: string) {
        return (
            <div className="col-12 notspace margin-top">
                <div className="tk-inline card-boundel course-header-card">
                    <div className="col-2 notspace" style={{ display: "flex" }}>
                        <img
                            className="icon"
                            src={courseImage}
                            width="56"
                            height="56"
                            alt="course icon"
                        />
                    </div>
                    <div
                        className="col-10 notspace"
                        style={{ textAlign: "right", marginRight: "20px" }}
                    >
                        <div className="pd-detail">
                            <div className="course-title">
                                <label>{courseTitle}</label>
                            </div>
                            <div className="course-subtitle">
                                <label>دسته بندی های این درس</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    categoriesView(categories: CourseNoteCategoryView[], courseTitle: string, courseImage: string) {
        const courseId = this.props.courseId;

        return (
            <>
                {categories.map((category) => {
                    const title = `تدریس ${category.title} ${courseTitle}`.trim();

                    return (
                        <NavLink
                            key={category.id}
                            to={`/CourseNoteList?courseId=${courseId}&categoryId=${category.id}`}
                            className="col-12 notspace margin-top category-link"
                        >
                            <div className="tk-inline card-boundel">
                                <div className="col-2 notspace" style={{ display: "flex" }}>
                                    <img
                                        className="icon"
                                        src={courseImage}
                                        width="56"
                                        height="56"
                                        alt="category icon"
                                    />
                                </div>
                                <div
                                    className="col-8 notspace"
                                    style={{ textAlign: "right", marginRight: "16px" }}
                                >
                                    <div className="pd-detail">
                                        <div className="course-title">
                                            <div className="tk-tooltip">
                                                {WordRestrictions(title, 32)}
                                            </div>
                                        </div>
                                        <div className="course-subtitle">
                                            <label>{`تدریس ${category.title} این درس`}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-2 notspace category-arrow">
                                    <label className="mdi mdi-chevron-left"></label>
                                </div>
                            </div>
                        </NavLink>
                    );
                })}
            </>
        );
    }
}
